/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CardRef,
  CardRefOptional,
  CardRefMetaI,
  CardRefTrackedI,
} from "./card-ref";
import { CardRefTracked, CardRefMeta } from "./card-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CheckInType,
  CheckInTypeOptional,
  CheckInTypeMetaI,
  CheckInTypeTrackedI,
} from "./check-in-type";
import { CheckInTypeTracked, CheckInTypeMeta } from "./check-in-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonCheckInBase,
  PersonCheckInBaseOptional,
  PersonCheckInBaseMetaI,
  PersonCheckInBaseTrackedI,
} from "./person-check-in-base";
import {
  PersonCheckInBaseTracked,
  PersonCheckInBaseMeta,
} from "./person-check-in-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonCheckInRef,
  PersonCheckInRefOptional,
  PersonCheckInRefMetaI,
  PersonCheckInRefTrackedI,
} from "./person-check-in-ref";
import {
  PersonCheckInRefTracked,
  PersonCheckInRefMeta,
} from "./person-check-in-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";

/**
 *
 * @export
 * @interface PersonCheckInFull
 */
export interface PersonCheckInFullOptional extends DeletableOptional {
  /**
   *
   * @type {number}
   * @memberof PersonCheckInFull
   */
  assignId?: number;
  /**
   *
   * @type {CheckInType}
   * @memberof PersonCheckInFull
   */
  checkInType?: CheckInType;
  /**
   *
   * @type {string}
   * @memberof PersonCheckInFull
   */
  checkInTime?: Date;
  /**
   *
   * @type {boolean}
   * @memberof PersonCheckInFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonCheckInFull
   */
  isNew?: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof PersonCheckInFull
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {CardRef}
   * @memberof PersonCheckInFull
   */
  cardId?: CardRefOptional;
}

export interface PersonCheckInFull
  extends
    PersonCheckInFullOptional,
    Deletable,
    PersonCheckInBase,
    PersonCheckInRef {
  /**
   *
   * @type {number}
   * @memberof PersonCheckInFull
   */
  assignId: number;
  /**
   *
   * @type {CheckInType}
   * @memberof PersonCheckInFull
   */
  checkInType: CheckInType;
  /**
   *
   * @type {string}
   * @memberof PersonCheckInFull
   */
  checkInTime: Date;
  /**
   *
   * @type {boolean}
   * @memberof PersonCheckInFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonCheckInFull
   */
  isNew?: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof PersonCheckInFull
   */
  personId: PersonRef;
  /**
   *
   * @type {CardRef}
   * @memberof PersonCheckInFull
   */
  cardId?: CardRef;
}

export interface PersonCheckInFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {number}
   * @memberof PersonCheckInFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {CheckInType}
   * @memberof PersonCheckInFull
   */
  checkInType?: CheckInType;
  checkInTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonCheckInFull
   */
  checkInTime?: Date;
  checkInTimeIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonCheckInFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonCheckInFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof PersonCheckInFull
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {CardRef}
   * @memberof PersonCheckInFull
   */
  cardId?: CardRefTrackedI;
  cardIdIsSet: boolean;
}

transformDatesMap.set("PersonCheckInFull", function (model: PersonCheckInFull) {
  if (typeof model.checkInTime == "string")
    model.checkInTime = new Date(model.checkInTime);
  const transformDatespersonId = transformDatesMap.get("PersonRef");
  if (transformDatespersonId && model.personId) {
    transformDatespersonId(model.personId);
  }
  const transformDatescardId = transformDatesMap.get("CardRef");
  if (transformDatescardId && model.cardId) {
    transformDatescardId(model.cardId);
  }
});

export type PersonCheckInFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  checkInType: PropertyMeta<CheckInTypeMetaI>;
  //isDate: false
  //isDatetime: true
  checkInTime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  cardId: PropertyMeta<CardRefMetaI>;
}>;

export var PersonCheckInFullMeta: PersonCheckInFullMetaI =
  {} as PersonCheckInFullMetaI;
PersonCheckInFullMeta = typeMeta("PersonCheckInFull", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  checkInType: propertyMeta("checkInType", false, true, false, CheckInTypeMeta),
  checkInTime: propertyMeta(
    "checkInTime",
    false,
    true,
    false,
    MetaTypesBase.Date,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
  cardId: propertyMeta("cardId", false, false, false, CardRefMeta),
});

const metaI = PersonCheckInFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonCheckInRefMeta]);
  metaI.assignId.inheritedFrom = PersonCheckInRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([PersonCheckInBaseMeta]);
  metaI.checkInType.inheritedFrom = PersonCheckInBaseMeta.checkInType;
  metaI.checkInTime.inheritedFrom = PersonCheckInBaseMeta.checkInTime;
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
});

export class PersonCheckInFullTracked
  extends DeletableTracked
  implements PersonCheckInFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  checkInType__I?: CheckInType = undefined;
  checkInTypeIsSet: boolean = false;
  set checkInType(v: undefined | CheckInType) {
    if (v !== undefined) {
      this.checkInType__I = v;
      this.checkInTypeIsSet = true;
    } else {
      this.checkInType__I = v || undefined;
      this.checkInTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get checkInType() {
    return this.checkInType__I;
  }
  checkInTime__I?: Date = undefined;
  checkInTimeIsSet: boolean = false;
  set checkInTime(v: undefined | Date) {
    if (v !== undefined) {
      this.checkInTime__I = v;
      this.checkInTimeIsSet = true;
    } else {
      this.checkInTime__I = v || undefined;
      this.checkInTimeIsSet = true;
    }
    this.changeTracker = true;
  }
  get checkInTime() {
    return this.checkInTime__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  cardId__I?: CardRefTracked = undefined;
  cardIdIsSet: boolean = false;
  set cardId(v: undefined | CardRefTracked) {
    if (v !== undefined) {
      this.cardId__I = v;
      this.cardIdIsSet = true;
    } else {
      this.cardId__I = v || undefined;
      this.cardIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get cardId() {
    return this.cardId__I;
  }
  constructor(config?: PersonCheckInFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personId?.setIds();

    this.cardId?.setIds();
  }
  assignFrom(
    config: PersonCheckInFullOptional,
    options?: AssignOptions,
  ): PersonCheckInFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.checkInType &&
      this.checkInTypeApplyFilter(optionsRequired.filter)
    ) {
      this.checkInType = config.checkInType;
      if (optionsRequired.unassign) this.checkInTypeIsSet = false;
      else this.checkInTypeIsSet = true;
    }
    if (
      config.checkInTime &&
      this.checkInTimeApplyFilter(optionsRequired.filter)
    ) {
      this.checkInTime = config.checkInTime;
      if (optionsRequired.unassign) this.checkInTimeIsSet = false;
      else this.checkInTimeIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (config.cardId && this.cardIdApplyFilter(optionsRequired.filter)) {
      this.cardId = new CardRefTracked(config.cardId, options);
      if (optionsRequired.unassign) this.cardIdIsSet = false;
      else this.cardIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonCheckInFullTrackedI {
    const cloned = {} as PersonCheckInFullTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.checkInTypeIsSetDeep() &&
      this.checkInTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.checkInTypeIsSet = true;
      cloned.checkInType = this.checkInType;
    } else {
      //cloned.checkInTypeIsSet = false
    }
    if (
      this.checkInTimeIsSetDeep() &&
      this.checkInTimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.checkInTimeIsSet = true;
      cloned.checkInTime = this.checkInTime;
    } else {
      //cloned.checkInTimeIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.cardIdIsSetDeep() &&
      this.cardIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cardIdIsSet = true;
      cloned.cardId = this.cardId?.removeUnset(filter);
    } else {
      //cloned.cardIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonCheckInFullTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.checkInTypeApplyFilter(filter)) this.checkInTypeIsSet = false;

    if (!this.checkInTimeApplyFilter(filter)) this.checkInTimeIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.cardIdApplyFilter(filter)) this.cardIdIsSet = false;
    this.cardId?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonCheckInFullMeta.assignId,
      PersonCheckInFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  checkInTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonCheckInFullMeta.checkInType,
      PersonCheckInFullMeta,
      this.checkInType,
      this,
    );
  }
  checkInTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.checkInTypeIsSet && this.checkInTypeApplyFilter(filter))
      return true;

    return false;
  }
  checkInTimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonCheckInFullMeta.checkInTime,
      PersonCheckInFullMeta,
      this.checkInTime,
      this,
    );
  }
  checkInTimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.checkInTimeIsSet && this.checkInTimeApplyFilter(filter))
      return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonCheckInFullMeta.isDeleted,
      PersonCheckInFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonCheckInFullMeta.isNew,
      PersonCheckInFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonCheckInFullMeta.personId,
      PersonCheckInFullMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  cardIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonCheckInFullMeta.cardId,
      PersonCheckInFullMeta,
      this.cardId,
      this,
    );
  }
  cardIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cardIdIsSet && this.cardIdApplyFilter(filter)) return true;
    return this.cardId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.checkInTypeIsSetDeep(filter)) return true;
    if (this.checkInTimeIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.cardIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
